import { createSelector } from '@reduxjs/toolkit'
import { get } from 'utils/lodash'
import { selectSortModel as selectPersistentSortModel } from 'slices/customer/persistentCustomerDetailsLocationsSlice'

const getCustomerDetailsLocationsState = state => get(state, 'customerDetailsLocations', {})

export const selectSelectedTab = createSelector([getCustomerDetailsLocationsState], state => get(state, 'selectedTab', 'active'))

export const selectExpandedRowIds = createSelector([getCustomerDetailsLocationsState], state => get(state, 'expandedRowIds', []))

export const selectSortModel = createSelector([selectPersistentSortModel], persistentSortModel => persistentSortModel)

export const selectFilters = createSelector([getCustomerDetailsLocationsState], state =>
  get(state, 'filters', { filterModel: { items: [], quickFilterExcludeHiddenColumns: false } })
)

export const selectActiveFiltersCount = createSelector([selectFilters], filters => {
  const filterItems = get(filters, 'filterModel.items', [])
  return filterItems.length
})

export const selectSelectedLocationForMenu = createSelector([getCustomerDetailsLocationsState], state =>
  get(state, 'selectedLocationForMenu', null)
)

export const selectLocationAnchorEl = createSelector([getCustomerDetailsLocationsState], state => get(state, 'locationAnchorEl', null))

export const selectMoreActionsAnchorEl = createSelector([getCustomerDetailsLocationsState], state =>
  get(state, 'moreActionsAnchorEl', null)
)

export const selectShowDeactivateAllConfirmation = createSelector([getCustomerDetailsLocationsState], state =>
  get(state, 'showDeactivateAllConfirmation', false)
)

export const selectIsOpenAddLocationDialog = createSelector([getCustomerDetailsLocationsState], state =>
  get(state, 'isOpenAddLocationDialog', false)
)
